/*** IMPORTS FROM imports-loader ***/
var define = false;

export class QuatreImagesUnMot {
    constructor(wrapper) {
        this.wrapper = wrapper;
        
        this.attempts = 5;
        this.boxes = this.wrapper.find('.word-entry-input input');
        this.buttons = this.wrapper.find('.word-entry-letters button');
        this.answer = this.wrapper.find('input[class^="answer_"]');
        this.count = this.wrapper.find('.word-entry-attempts-count');

        this.goodChoice = this.wrapper.find('.gfield_radio .gchoice').first().find('.gfield-choice-input');

        this.submitButton = this.wrapper.find('.gform_next_button, .gform_button');

        this.buttons.on('click', this.addLetter.bind(this));
        this.boxes.on('click', this.removeLetter.bind(this));
    }

    addLetter(e) {
        let button = $(e.target).closest('button');
        let letter = button.text();
        let key = button.data('key');
        let box = this.boxes.filter((i, box) => !$(box).val()).first();        
        
        button.prop('disabled', true);
        box.val(letter).data('key', key).addClass('hasLetter');

        this.check();
    }

    removeLetter(e) {
        let box = $(e.target).closest('input');
        let key = box.data('key');

        let button = this.buttons.filter((i, button) => $(button).data('key') == key).first();

        button.prop('disabled', false);
        box.val('').data('key', '').removeClass('hasLetter');
    }

    check() {
        let word = this.boxes.map((i, box) => {
            return $(box).val();
        }).get().join('');
        
        if(word.length < this.answer.val().length) return;

        if(word.toLowerCase() == this.answer.val().toLowerCase()) {
            this.success();
        } else {
            this.error();
        }
    }

    success() {
        this.boxes.addClass('success');
        this.boxes.prop('disabled', true);
        this.buttons.prop('disabled', true);
        
        this.goodChoice.prop('checked', true);
        this.submitButton.show();
    }

    error() {
        this.boxes.addClass('error');
        this.buttons.prop('disabled', true);

        this.attempts--;
        this.count.text(this.attempts);

        if(this.attempts > 0) {
            setTimeout(() => {
                this.boxes.val('').data('key', '').removeClass('error').removeClass('hasLetter');
                this.buttons.prop('disabled', false);
            }, 500);
        } else {
            this.goodChoice.prop('checked', false);
            this.submitButton.show();
        }

    }
}

export default {
    init: (app) => {
        $('.gform_page').each(function(){
            new QuatreImagesUnMot($(this));
        });

        // const boxes = $('.word-entry-input input');
        // const buttons = $('.word-entry-letters button');
        // const answer = $('input[class^="answer_"]');
        // let errors = 0;

        // let choice = $('.gfield_radio .gchoice');
        // choice.clone().insertAfter(choice);

        // function addLetter(letter) {
        //     let box = boxes.filter((i, v) => !$(v).val()).first();

        //     box.val(letter).addClass('hasLetter');

        //     checkWord();
        // }
        
        // function checkWord() {
        //     let word = boxes.map((i, box) => {
        //         return $(box).val();
        //     }).get().join('');
            
        //     if(word.length < answer.val().length) return;

        //     if(word.toLowerCase() == answer.val().toLowerCase()) {
        //         success();
        //     } else {
        //         error();
        //     }

        //     // let arr = $("input[name='" + wordID + "[]']").map(function () { return $(this).val(); }).get();
        //     // let final_word = arr.join('');
        //     // let answer = $("input.answer_" + wordID).val();

        //     // if (arr.indexOf("") == -1) {
        //     //     if (final_word.toLowerCase() == answer.toLowerCase()) {
        //     //         $("input[name='" + wordID + "[]']").addClass("success");
        //     //         $("input[value='" + wordID + "']").attr("checked", true);
        //     //         $(".gform_next_button, .gform_button").show();
        //     //     }
        //     //     else {
        //     //         $("input[name='" + wordID + "[]']").addClass("error");
        //     //     }
        //     // }

        // }

        // function success() {
        //     boxes.addClass('success');
        //     boxes.prop('disabled', true);
            
        //     $('.gfield-choice-input').prop('checked', true);
        //     $(".gform_next_button, .gform_button").show();
        // }

        // function error() {
        //     boxes.addClass('error');
        //     buttons.prop('disabled', true);

        //     errors++;

        //     if(errors < 5) {
        //         setTimeout(() => {
        //             boxes.val('').removeClass('error').removeClass('hasLetter');
        //             buttons.prop('disabled', false);
        //         }, 500);
        //     } else {
        //         $(".gform_next_button, .gform_button").show();
        //     }
        // }

        // buttons.on('click', (e) => {
        //     let button = $(e.target).closest('button');
        //     let letter = button.text();
        //     // let key = button.data('key');
        //     // let word = button.data('word');
        //     // let values = boxes.map((i, input) => {
        //     //     return $(input).val();
        //     // }).get();

        //     button.prop('disabled', true);

        //     // addLetter(letter, values, word, key);
        //     addLetter(letter);
        // });

        /**
         * On letter button click event
         */
        // $('.word-entry-letters button').on("click", function (e) {
        //     let letter = $(this).text();
        //     let wordID = $(this).data("word");
        //     let values = $("input[name='" + wordID + "[]']").map(function () { return $(this).val(); }).get();
        //     let key = $(this).data("key");

        //     $(this).attr("disabled", "")

        //     addLetter(letter, values, wordID, key);
        // })


        /**
         * 
         * Function to add letter to case box
         */
        // function addLetter(letter, arr, wordID, key) {


        //     for (let [index, elem] of arr.entries()) {
        //         if (!elem) {
        //             $("input[name='" + wordID + "[]']").eq(index).val(letter).attr("data-key", key).addClass("hasLetter")
        //             checkWord(wordID);
        //             break;
        //         }
        //     };


        // }

        /**
         * On input click event
         */
        // $('.word-entry-input input').on("click", function (e) {
        //     let value = $(this).val();
        //     $(".word-entry-input input").removeClass("error")
        //     if (value) {
        //         let key = $(this).attr("data-key");
        //         // console.log(key)
        //         $('.word-entry-letters button[data-key=' + key + ']').removeAttr("disabled")
        //         $(this).val("").removeAttr("data-key").removeClass("hasLetter");
        //     }
        // })



        /**
         * Function to check the word
         */
        // function checkWord(wordID) {
        //     let arr = $("input[name='" + wordID + "[]']").map(function () { return $(this).val(); }).get();
        //     let final_word = arr.join('');
        //     let answer = $("input.answer_" + wordID).val();

        //     if (arr.indexOf("") == -1) {
        //         if (final_word.toLowerCase() == answer.toLowerCase()) {
        //             $("input[name='" + wordID + "[]']").addClass("success");
        //             $("input[value='" + wordID + "']").attr("checked", true);
        //             $(".gform_next_button, .gform_button").show();
        //         }
        //         else {
        //             $("input[name='" + wordID + "[]']").addClass("error");
        //         }
        //     }

        // }


    }
}
